import { Component, Input } from '@angular/core';
import { FaqInterface } from '@app/core/interfaces';

/** @deprecated - this is moved to libs */
@Component({
    selector: 'ins-faq',
    templateUrl: 'faq.component.html',
    styleUrls: ['faq.component.scss'],
})
export class FaqComponent {
    @Input() type: string = null;
    @Input() data: FaqInterface;
}
